import { toast } from "react-toastify"

import logo from '../assets/images/logo-mini.png'

async function init() {
	const permission = await Notification.requestPermission()

	if(permission !== 'granted') {
		throw new Error('Permissão negada para notificações!')
	}
}

try {
	init()
} catch(e) {
	console.log(e.message)
}

export function notify({ title = 'Notification', content, onClick }) {
	const isWindowAvailable = typeof window !== 'undefined'

	if(isWindowAvailable) {
		if(Notification.permission === 'granted') {
			const notification = new Notification(title, { 
				body: content, 
				icon: logo,
				requireInteraction: true
			})

			if(onClick) {				
				notification.onclick = onClick
			}
		} else {
			toast(content)
		}
	}
}